import React, {useEffect, useState} from 'react';
import {Pagination, Paper, Skeleton, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack'


export interface IPdfStep {
    stepKey: string;
    file?: any;
}

const PdfStep = (props: IPdfStep) => {
    const {t} = useTranslation(['network']);
    const width = window.innerWidth * 80 / 100;
    const [height, setHeight] = useState('60vh');
    const styles = {
        title: {
            marginBottom: "16px",
        },
        pagination: {
            marginTop: "16px",
            display: 'flex',
            justifyContent: 'center'
        }
    };

    const [numPages, setNumPages] = useState(0);

    function onDocumentLoadSuccess({numPages}: any) {
        setNumPages(numPages);
    }

    useEffect(() => {
        setHeight(props.stepKey === 'pdf' ? '80vh' : (props.stepKey === 'init' ? '70vh' : '60vh'));
    }, [props.stepKey]);

    return (
        <>
            <Typography variant="h6" sx={styles.title}>{t(`digitalSign.step.${props.stepKey}.title`)}</Typography>
            {!!props.file ?
                <Paper elevation={1} sx={{maxHeight:height, overflow:'scroll'}}>
                    <Document file={`data:application/pdf;base64,${props.file}`} onLoadSuccess={onDocumentLoadSuccess}
                              onLoadError={(e) => {
                                  console.log(e);
                              }}
                              loading={<Skeleton variant="rectangular" width={width} height={height}/>}
                    >
                        {Array.from(new Array(numPages), (el, index) => (
                            <Page key={`page_${index + 1}`} pageNumber={index + 1} renderTextLayer={false} width={width}/>
                        ))}
                    </Document>
                </Paper>
                : <Skeleton variant="rectangular" width={width} height={height}/>
            }
        </>
    );
};

export default PdfStep;